import { tw } from '@/utils/tw';

const Blip = tw.theme({
  base: 'inline-block h-2 w-2 rounded-full bg-primary-700 before:absolute before:inline-block before:h-2 before:w-2 before:animate-blip-inner-circle before:rounded-full before:bg-primary-700 after:absolute after:inline-block after:h-2 after:w-2 after:animate-blip-outer-circle after:rounded-full after:bg-primary-700',
});

export default Blip;
